import { MESSAGES_EVENTS } from '../../../../config/config';
import socket from '../../../socket';
import getMessagesHistory from './utils/getMessagesHistory';
import setMessageAsReceive from './utils/setAsReceived';

export default async ({ rootState, commit }, userToken) => {
  const bearerToken = rootState['DATA-ACCESS'].tokenAuth;
  if (!userToken) {
    return;
  }
  socket.off(MESSAGES_EVENTS.CONSUMER_PRIVATE_MESSAGE);
  const messages = await getMessagesHistory(bearerToken, userToken);
  commit('consumerMessages', messages);
  socket.emit(MESSAGES_EVENTS.READ_CONSUMER);

  socket.on(
    MESSAGES_EVENTS.CONSUMER_PRIVATE_MESSAGE,
    async ({ messages, info }) => {
      if (info.from === userToken || info.to === userToken) {
        messages.forEach(message => commit('pushConsumerMessages', message));
        if (info.from === userToken) {
          const messagesIds = messages.map(message => message._id);
          await setMessageAsReceive(bearerToken, { messagesIds });
          socket.emit(MESSAGES_EVENTS.READ_CONSUMER);
        }
      }
    },
  );
};
